import React from 'react';
import { ContainerComponent, wrap } from 'AppReact';
import { Icon, SecondaryTextXs, Text, CustomInput, CustomTitle } from 'atoms';
import {
  RelativeWrapper, UnitDropdownBodyWrapper, FilterHeaderWrapper,
  CursorPointerWrapper, FlexCenterWrapper, BorderBottomWrapper, Mt2, Ml2,
  Mt3, Mb3, Mr3, Mr1, Mt6, Ml4, HoverPrimary50BackgroundWrapper, TemplateOptionItemWrapper,
  GraySvgWrapper, TemplateOptionsItemWrapper, FullWidthRowCenterScrollWrapper
} from 'wrappers';
import Controller from './controller';
import internalState from './internalState';
import { DownCaretSvg } from 'components/icons';
import { options, customOptions } from './utils';
import { getIconByName } from '../multipleOptionsButton/utils';

const containerRef = React.createRef();

export const definition = {
  name: 'Dropdown',
  controller: Controller,
  initialProps: ({ selectedOptions, openOnTop, hasCharges, item }) => ({ selectedOptions, openOnTop, hasCharges, item }),
  props: internalState,
  elements: [
    {
      wrapper: FilterHeaderWrapper,
      name: 'Selector',
      isButton: true,
      bindings: ({ isOpen, selectedOptions }) => ({ isOpen, containerRef, selectedOptions }),
      displayState: ({ hasCharges, selectedOptions, item }) => ({ height: hasCharges && selectedOptions?.length > 0 && item.input_type === 'options' ? '86px' : '42px' }),
      elements: [
        {
          wrapper: FullWidthRowCenterScrollWrapper,
          name: '__transparent__',
          renderIf: ({ selectedOptions }) => !!selectedOptions && selectedOptions.length > 0,
          elements: [
            {
              wrapper: TemplateOptionsItemWrapper,
              displayState: ({ hasCharges, item }) => {
                return { height: hasCharges && item.input_type === 'options' ? '70px' : '27px', width: item.input_type !== 'options' ? '100%' : '', color: item.input_type !== 'options' ? '#9EACB0' : '#1DBD6B' }
              },
              name: 'OptionsButton',
              elements: [
                {
                  wrapper: TemplateOptionItemWrapper,
                  isListOf: 'selectedOptions',
                  displayState: ({ selectedOptionIndex, selectedOptions, item }) => ({
                    hideBorder: selectedOptionIndex === selectedOptions?.length - 1,
                    width: item?.input_type !== 'options' ? '100%' : ''
                  }),
                  name: '__transparent__',
                  elements: [
                    {
                      wrapper: FlexCenterWrapper,
                      name: 'OptionWrapper',
                      elements: [
                        {
                          component: Icon,
                          name: 'Icon',
                          renderIf: ({ selectedOption }) => !!getIconByName({ name: selectedOption.name }),
                          displayValue: ({ selectedOption }) => getIconByName({ name: selectedOption.name })
                        },
                        {
                          component: Text,
                          name: 'Text',
                          displayValue: ({ selectedOption }) => selectedOption.name ?? ''
                        }
                      ]
                    },
                    {
                      component: wrap(CustomInput, Mt2),
                      name: 'Input',
                      renderIf: ({ selectedOption, hasCharges, item }) => !selectedOption?.is_na && hasCharges && item.input_type === 'options',
                      bindings: ({ selectedOption, selectedOptions }) => ({ selectedOption, selectedOptions, value: selectedOption?.cost !== null && selectedOption?.cost !== '' ? `$${selectedOption?.cost ?? ''}` : '', placeholder: "$" }),
                      displayState: ({ selectedOption }) => ({ fontSize: selectedOption?.cost?.length > 6 ? '10px' : '14px' }),
                    }
                  ]
                }
              ]
            },
          ]
        },
        {
          component: SecondaryTextXs,
          name: 'NoOptions',
          renderIf: ({ selectedOptions }) => selectedOptions.length === 0 || !selectedOptions,
          displayValue: ({ }) => 'Pick Selector'
        },
        {
          component: wrap(Icon, Ml2),
          name: 'DownCaretSvg',
          displayValue: () => DownCaretSvg({}),
          bindings: () => ({})
        }
      ]
    },
    {
      wrapper: UnitDropdownBodyWrapper,
      name: 'Body',
      ref: () => containerRef ?? null,
      displayState: ({ openOnTop }) => ({ openOnTop }),
      renderIf: ({ isOpen }) => isOpen,
      elements: [
        {
          component: wrap(wrap(wrap(CustomTitle, Mt6), Mb3), Ml4),
          name: 'Options',
          displayValue: ({ }) => 'SELECTOR'
        },
        {
          wrapper: wrap(wrap(wrap(FlexCenterWrapper, HoverPrimary50BackgroundWrapper), CursorPointerWrapper), BorderBottomWrapper),
          name: 'Option',
          isListOf: { option: ({ }) => options },
          isButton: true,
          bindings: ({ option }) => ({ option }),
          elements: [
            {
              wrapper: wrap(wrap(FlexCenterWrapper, Mt3), Mb3),
              name: 'Wrapper',
              elements: [
                {
                  wrapper: wrap(FlexCenterWrapper, Mr3),
                  name: 'ElementWrapper',
                  isListOf: { element: ({ option }) => option },
                  elements: [
                    {
                      component: wrap(wrap(Icon, Mr1), GraySvgWrapper),
                      name: 'Icon',
                      renderIf: ({ element }) => !!getIconByName({ name: element.name }),
                      displayValue: ({ element }) => getIconByName({ name: element.name })
                    },
                    {
                      component: SecondaryTextXs,
                      name: 'Text',
                      displayValue: ({ element }) => element.name ?? ''
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          component: wrap(wrap(wrap(CustomTitle, Mt6), Mb3), Ml4),
          name: 'CustomOptions',
          displayValue: ({ }) => 'CUSTOM INPUT'
        },
        {
          wrapper: wrap(wrap(wrap(FlexCenterWrapper, HoverPrimary50BackgroundWrapper), CursorPointerWrapper), BorderBottomWrapper),
          name: 'CustomOption',
          isListOf: { option: ({ }) => customOptions },
          isButton: true,
          bindings: ({ option }) => ({ option }),
          elements: [
            {
              wrapper: wrap(wrap(FlexCenterWrapper, Mt3), Mb3),
              name: 'Wrapper',
              elements: [
                {
                  wrapper: wrap(FlexCenterWrapper, Mr3),
                  name: 'ElementWrapper',
                  elements: [
                    {
                      component: SecondaryTextXs,
                      name: 'Text',
                      displayValue: ({ option }) => option.display_value ?? ''
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};

export default wrap(ContainerComponent(definition), RelativeWrapper);
